import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import RouteFallback from '../route-fallback';

export default function PageOutlet() {
  return (
    <Suspense fallback={<RouteFallback />}>
      <Outlet />
    </Suspense>
  );
}
